import { render, staticRenderFns } from "./politica.vue?vue&type=template&id=10556e4a"
import script from "./politica.vue?vue&type=script&lang=js"
export * from "./politica.vue?vue&type=script&lang=js"
import style0 from "./politica.vue?vue&type=style&index=0&id=10556e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports